"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function makeCreateLogger(formatFunc) {
    return function createLogger(namespace, opt) {
        if (namespace === void 0) { namespace = ''; }
        if (opt === void 0) { opt = {}; }
        function invariant(check, message) {
            if (message === void 0) { message = ''; }
            if (!check) {
                throw new Error(format({ message: message }));
            }
        }
        function format(arg) {
            if (arg === void 0) { arg = {}; }
            return formatFunc(__assign({ namespace: namespace, argv: [] }, arg), __assign({}, opt));
        }
        function log(message) {
            var argv = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                argv[_i - 1] = arguments[_i];
            }
            console.log(format({ message: message, argv: argv, type: 'Info' }));
        }
        function success(message) {
            var argv = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                argv[_i - 1] = arguments[_i];
            }
            console.log(format({ message: message, argv: argv, type: 'Success' }));
        }
        function warn(message) {
            var argv = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                argv[_i - 1] = arguments[_i];
            }
            console.warn(format({ message: message, argv: argv, type: 'Warning' }));
        }
        function error(message) {
            var argv = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                argv[_i - 1] = arguments[_i];
            }
            console.error(format({ message: message, argv: argv, type: 'Error' }));
        }
        return {
            invariant: invariant,
            format: format,
            log: log,
            info: log,
            success: success,
            warn: warn,
            debug: require('debug')(namespace),
            error: error
        };
    };
}
exports.default = makeCreateLogger;
//# sourceMappingURL=makeCreateLogger.js.map